// extracted by mini-css-extract-plugin
export var alignBaseline = "_n-9";
export var alignCenter = "_n-5";
export var alignFlexEnd = "_n-7";
export var alignFlexStart = "_n-6";
export var alignSelfBaseline = "_n-e";
export var alignSelfCenter = "_n-a";
export var alignSelfFlexEnd = "_n-c";
export var alignSelfFlexStart = "_n-b";
export var alignSelfStretch = "_n-d";
export var alignStretch = "_n-8";
export var column = "_n-2";
export var columnReverse = "_n-4";
export var flex = "_n-0";
export var justifyCenter = "_n-f";
export var justifyFlexEnd = "_n-h";
export var justifyFlexStart = "_n-g";
export var justifySpaceAround = "_n-j";
export var justifySpaceBetween = "_n-i";
export var justifySpaceEvenly = "_n-k";
export var row = "_n-1";
export var rowReverse = "_n-3";
export var wrapNowrap = "_n-m";
export var wrapWrap = "_n-l";
export var wrapWrapReverse = "_n-n";